import { render, staticRenderFns } from "./KeyTakeaways.vue?vue&type=template&id=85df9782"
import script from "./KeyTakeaways.vue?vue&type=script&lang=js"
export * from "./KeyTakeaways.vue?vue&type=script&lang=js"
import style0 from "./KeyTakeaways.vue?vue&type=style&index=0&id=85df9782&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports